module.exports = "query($date: [String!]) {\n    getAiErrors(date: $date) {\n        count\n        name\n    }\n}\n"